export default __webpack_public_path__ + "static/media/blood-icon.d4676aac.png";